import React, { useEffect, useState } from 'react'
import Image from '../../../components/common/Image'
import Toggle from '../../../components/common/toggle'
import Input from '../../../components/common/Input'
import Switch from '../../../components/common/switch/Switch'
import Notification from '../../../components/common/Error/Notification'
import { useNavigate } from 'react-router-dom'
import { serviceInfo } from './text'

const Service = ({ serviceType, parameters, data, onBack, onSubmit, userInfo }) => {
    const navigate = useNavigate()
    const [modal, setModal] = useState(false)
    const [submitData, setSubmitData] = useState({
        is_cargo: { name: "否", value: false }
    })
    const [questionList, setQuestionList] = useState([])
    const onAction = (confirm) => {
        if (!confirm) {
            setModal(confirm)
            let obj = { ...submitData }
            delete obj[modal.key]
            setSubmitData(obj)

        } else {
            navigate("/add?service=1")
            setModal(false)
        }

    }

    const disabledBtn = () => {
        let validation = []
        questionList.forEach(q => {
            let sub = q.sub
            validation.push(submitData[q.key] ? 1 : 0)
            if (sub) {
                if (submitData[q.key]?.value === sub.value) {
                    // console.log(q.sub)
                    let key = q.sub.key ? q.sub.key : q.sub.question.key
                    validation.push(key)
                    validation.push(submitData[key] ? 1 : 0)


                    // if(q.sub.key){
                    //     //input
                    // }else if(q.sub.question){
                    //     validation.push(submitData[q.sub.question.key] ? 1 : 0)

                    // }

                }
            }
        })
        return validation.filter(v => !v).length
    }
    useEffect(() => {
        let obj= data.service ?
        data.service : { is_cargo: { name: "否", value: false } }
        // const { questions } = serviceInfo[serviceType]
        const car_type = userInfo.type?.value
        let questions = serviceInfo[serviceType].questions
        if (car_type === 'scooter') {
            //選擇車款為機車時，隱藏「打N檔」、「手煞車」兩個選項。給後端資料默認為"不行"之結果
            questions = questions.filter(q => {
                if(q.key !== 'car_gear' && q.key !== 'car_handbrake'){
                    return q
                }else{
                    obj[q.key] = q.option.filter(o=> !o.value)[0]
                }
            })
        }
        setQuestionList(questions)
        setSubmitData( obj)
    }, [data])


    return (
        <div className='container'>
            <div className="page-header">
                <button className='btn-circle' onClick={onBack}>
                    <Image src='/images/icons/arrow_left.svg' />
                </button>
                <div className="page_header__title">
                    <h1 className="font-heading">服務問題</h1>
                    <p className="text-secondary text-scale-02">
                        這將使我們派出最適合的支援
                    </p>
                </div>

            </div>
            <div className='column-flex-grow-container'>
                <div className='flex-grow-1'>
                    {
                        questionList.map(q =>
                            (q.option && q.key !== 'is_cargo') ||
                                (q.key === 'is_cargo' && (serviceType === "1" || serviceType === "6") && userInfo.model.isTruck) ?
                                (<>
                                    <Toggle
                                        key={q.key}
                                        style={{ marginTop: 16 }}
                                        defaultValue={submitData[q.key]}
                                        info={q.desc}
                                        label={q.label}
                                        list={q.option}
                                        onChange={(data) => {
                                            let obj = { ...submitData }
                                            if (q.disabled && data.value === q.disabled.value) {
                                                setModal({ ...q.disabled, key: q.key })
                                            } else {
                                                setModal(false)
                                            }
                                            let sub = q.sub
                                            if (sub) {
                                                let key =
                                                    sub.type === 'option' ?
                                                        sub.question.key : sub.key
                                                delete obj[key]
                                            }
                                            obj[q.key] = data
                                            setSubmitData(obj)
                                        }}
                                    />
                                    {
                                        (q.sub && q.sub.value === submitData[q.key]?.['value']) && (
                                            q.sub.type === 'input' ? (
                                                <Input
                                                    style={{ marginTop: 8 }}
                                                    defaultValue={submitData[q.sub.value]}
                                                    rules={q.sub.rules}
                                                    onChange={(val) => {
                                                        setSubmitData({ ...submitData, [q.sub.key]: val })
                                                    }}
                                                    placeholder={q.sub.placeholder}
                                                />) : (<Toggle
                                                    key={q.sub.question.key}
                                                    style={{ marginTop: 16 }}
                                                    defaultValue={submitData[q.sub.question.key]}
                                                    label={q.sub.question.label}
                                                    list={q.sub.question.option}
                                                    onChange={(data) => {
                                                        let question = q.sub.question
                                                        let obj = { ...submitData }
                                                        // if(q.disabled && data.value === q.disabled.value){
                                                        //     setModal({...q.disabled, key:q.key})
                                                        // }else{
                                                        //     setModal(false)
                                                        // }
                                                        obj[question.key] = data
                                                        setSubmitData(obj)
                                                    }}
                                                />)
                                        )
                                    }

                                </>) : (<>
                                    {
                                        (serviceType === "1" || serviceType === "6") && userInfo.model.isTruck &&
                                        <Switch
                                            style={{ marginTop: 24 }}
                                            title={q.label}
                                            info={q.info}
                                            defaultValue={submitData[q.key]?.value}
                                            onChange={(data) => {
                                                let obj = { ...submitData }
                                                let key = q.sub ? q.sub.question.key : q.key
                                                obj[key] = data
                                                setSubmitData(obj)
                                            }}

                                        />

                                    }

                                </>))
                    }
                </div>
                <button
                    style={{ marginTop: 24 }}
                    className="btn"
                    disabled={disabledBtn()}
                    onClick={() => onSubmit(submitData)}
                >確定</button>
            </div>
            {
                modal && (
                    <Notification
                        {...modal}
                        onConfirm={() => onAction(true)}
                        onBnt02={() => onAction(false)}
                    // title='要離開了嗎？' 
                    // description='案件尚未成立，剛剛填入的資料將不會保存' 
                    // btn02Text='確定離開'
                    // okText='繼續填寫'
                    // onConfirm={()=> setModal(false)}
                    // onBnt02={()=>navigate(-1)}
                    />
                )
            }
        </div>
    )
}

export default Service